import { Flex, localeIRNumberFormatter } from '@zoomit/primitives';
import { Typography, cssVar, theme } from '@zoomit/zoomit-ds';

type Props = {
  priceFrom: number;
  priceTo: number;
  direction?: 'row' | 'column';
  fontVariant?: 'large' | 'medium' | 'small';
};

const RangePrice = (props: Props) => {
  const { priceFrom, priceTo, direction = 'row', fontVariant = 'medium' } = props;

  const getRootGap = () => {
    switch (direction) {
      case 'column':
        return 0.8;
      default:
        return 0.4;
    }
  };

  return (
    <Flex
      flexDirection={direction}
      gap={getRootGap()}
      flexWrap="nowrap"
      justifyContent={direction === 'row' ? 'center' : 'flex-start'}
    >
      {priceFrom !== 0 && (
        <Typography
          variant={fontVariant === 'medium' ? 'subhead' : 'callout'}
          textColor={cssVar(theme.grey1)}
        >
          از
          <Typography
            spacing={{ mx: 'x' }}
            className="fa"
            tag="span"
            fontWeight={fontVariant === 'small' ? 'bold' : undefined}
            variant={fontVariant === 'medium' ? 'h5' : fontVariant === 'small' ? 'subhead' : 'h4'}
            textColor={cssVar(theme.success1)}
          >
            {localeIRNumberFormatter(priceFrom)}
          </Typography>
          تومان
        </Typography>
      )}
      {priceTo !== 0 && (
        <Typography
          variant={fontVariant === 'medium' ? 'subhead' : 'callout'}
          textColor={cssVar(theme.grey1)}
        >
          تا
          <Typography
            spacing={{ mx: 'x' }}
            className="fa"
            tag="span"
            fontWeight={fontVariant === 'small' ? 'bold' : undefined}
            variant={fontVariant === 'medium' ? 'h5' : fontVariant === 'small' ? 'subhead' : 'h4'}
            textColor={cssVar(theme.error)}
          >
            {localeIRNumberFormatter(priceTo)}
          </Typography>
          تومان
        </Typography>
      )}
    </Flex>
  );
};

export default RangePrice;
